var map = {
	"./01.png": 65220,
	"./02.png": 39492,
	"./03.png": 11174,
	"./04.png": 57131,
	"./05.png": 67045,
	"./06.png": 29519,
	"./07.png": 93803,
	"./08.png": 71827,
	"./09.png": 32355,
	"./10.png": 30989,
	"./11.png": 87025,
	"./12.png": 85592,
	"./13.png": 69019,
	"./14.png": 75325,
	"./15.png": 46921,
	"./coin.png": 76336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85409;